import React from 'react';
import {SuccessBox} from 'iss/widgets/MessageBox';
import {translate} from 'iss/strings';

require('iss/styles/global.styl');

class LoggedOutPage extends React.Component {
  render() {
    return <div style={{margin: '1em'}}>
      <SuccessBox message={translate('loggedOut.message')} />
    </div>;
  }
}

export default LoggedOutPage;



// WEBPACK FOOTER //
// ./modules/issFrontend/pages/LoggedOutPage.jsx